import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { GetRoutes } from './routes/getRoutes';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Router>
          <GetRoutes />
        </Router>
      </Provider>
    </div>
  );
}

export default App;
